import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Spin, Tooltip } from 'antd';

import { useTranslation } from 'react-i18next';
import IconNoData from '../../../assets/Images/icons/icon-no-data';
import { memo, useMemo } from 'react';
import { Line } from '@ant-design/charts';

const Overview2 = memo(function Overview2({
    isLoadingConsent,
    cookieConsentDetail,
}) {
    const { t } = useTranslation();

    const config = useMemo(() => {
        return {
            data: cookieConsentDetail?.graph,
            xField: 'date',
            yField: 'value',
            seriesField: 'type',
            smooth: true,
            color: ({ type }) => {
                switch (type) {
                    case t('COOKIE.AcceptAll'):
                        return '#1890FF';
                    case t('COOKIE.CookieConsent'):
                        return '#2CD9C5';
                    default:
                        return '#2CD9C5';
                }
            },
            style: {
                cursor: 'pointer',
            },
            lineStyle: {
                lineWidth: 3,
            },
            legend: {
                layout: 'horizontal',
                marker: {
                    symbol: 'circle',
                },
            },
            state: {
                active: {
                    animate: { duration: 100, easing: 'easeLinear' },
                    style: {
                        cursor: 'pointer',
                        lineWidth: 2,
                        stroke: '#000',
                    },
                },
            },
            xAxis: {
                label: {
                    autoRotate: true,
                    style: {
                        cursor: 'pointer',
                        fill: '#505D6F',
                        fontWeight: 600,
                        fontSize: 12,
                    },
                },
            },
            yAxis: {
                label: {
                    autoRotate: true,
                    style: {
                        cursor: 'pointer',
                        fill: '#505D6F',
                        fontWeight: 600,
                        fontSize: 12,
                    },
                },
            },
            tooltip: {
                customContent: (title, data) => {
                    return (
                        <div className="p-3 text-xs font-semibold">
                            <div className="py-1 flex space-x-4">{title}</div>
                            {data.map((item, index) => (
                                <div
                                    key={index}
                                    className="py-1 flex space-x-4"
                                >
                                    <svg
                                        width="12"
                                        height="13"
                                        viewBox="0 0 12 13"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <circle
                                            cx="6"
                                            cy="6.5"
                                            r="6"
                                            fill={item.color}
                                        />
                                    </svg>
                                    <div>{t(item.data.type)}</div>
                                    <div>{item.data.value}</div>
                                </div>
                            ))}
                        </div>
                    );
                },
            },
        };
    }, [cookieConsentDetail, t]);

    return (
        <Spin spinning={isLoadingConsent}>
            <div className="flex space-x-2 items-center pb-4 justify-between">
                <div className="font-semibold text-xl">
                    {t('COOKIE.OverviewCookieConsent')}{' '}
                    {cookieConsentDetail?.dateLabel}
                </div>
                <div>
                    <Tooltip
                        placement="right"
                        overlayClassName="min-w-[300px]"
                        title={t('COOKIE.TooltipGraph')}
                    >
                        <a className="bg-purple-light p-2 flex items-center justify-center rounded-lg text-purple">
                            <ExclamationCircleOutlined />
                        </a>
                    </Tooltip>
                </div>
            </div>

            {cookieConsentDetail?.length <= 0 ? (
                <div className="text-center text-sm space-y-2 my-32">
                    <IconNoData />
                    <p className="text-[#65707A] text-[14px]">
                        {t('common.noData')}
                    </p>
                </div>
            ) : (
                <Line {...config} />
            )}
        </Spin>
    );
});

export default Overview2;
